import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/index'
import Disclosure from '@/views/Disclosure/index'
import LifeCycle from '@/views/LifeCycle/index'
import ServiceGuide from '@/views/ServiceGuide/index'
import EnterDisclosure from '@/views/EnterDisclosure/index'
import OnlineApplication from '@/views/OnlineApplication/index'
import MyOffice from '@/views/MyOffice/index'
import HandlingDetails from '@/views/HandlingDetails/index'
import WeiXinLogin from '@/views/WeiXinLogin/index'
import LoginSuccess from '@/views/LoginSuccess/index'
import Personal from '@/views/Personal/index'
// import MyMaterials from '@/views/MyMaterials/index'
import BasicInformationBinding from '@/views/BasicInformationBinding/index'
import HanYuan from '@/views/CharacteristicVillage/HanYuan/index'
import AnLe from '@/views/CharacteristicVillage/AnLe/index'
import DaShu from '@/views/CharacteristicVillage/DaShu/index'
import FuLin from '@/views/CharacteristicVillage/FuLin/index'
import FuQuan from '@/views/CharacteristicVillage/FuQuan/index'
import FuXiang from '@/views/CharacteristicVillage/FuXiang/index'
import FuZhuang from '@/views/CharacteristicVillage/FuZhuang/index'
import HeNan from '@/views/CharacteristicVillage/HeNan/index'
import HuangMu from '@/views/CharacteristicVillage/HuangMu/index'
import JiuXiang from '@/views/CharacteristicVillage/JiuXiang/index'
import MaLie from '@/views/CharacteristicVillage/MaLie/index'
import NiMei from '@/views/CharacteristicVillage/NiMei/index'
import PianMa from '@/views/CharacteristicVillage/PianMa/index'
import QianYu from '@/views/CharacteristicVillage/QianYu/index'
import QingXi from '@/views/CharacteristicVillage/QingXi/index'
import ShaiJin from '@/views/CharacteristicVillage/ShaiJin/index'
import ShunHe from '@/views/CharacteristicVillage/ShunHe/index'
import TangJia from '@/views/CharacteristicVillage/TangJia/index'
import WuSiHe from '@/views/CharacteristicVillage/WuSiHe/index'
import XiaoBao from '@/views/CharacteristicVillage/XiaoBao/index'
import YiDong from '@/views/CharacteristicVillage/YiDong/index'
import YongLi from '@/views/CharacteristicVillage/YongLi/index'
import HeadBanner from '@/components/HeadBanner/index'
import FootBanner from '@/components/FootBanner/index'
Vue.component('head-banner', HeadBanner)
Vue.component('foot-banner', FootBanner)
Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    // {
    //   path: '/Disclosure',
    //   name: 'Disclosure',
    //   component: Disclosure,
    // },
    {
      path: '/LifeCycle',
      name: 'LifeCycle',
      component: LifeCycle,
    },
    {
      path: '/ServiceGuide',
      name: 'ServiceGuide',
      component: ServiceGuide,
    },
    // {
    //   path: '/EnterDisclosure',
    //   name: 'EnterDisclosure',
    //   component: EnterDisclosure,
    // },
    // {
    //   path: '/OnlineApplication',
    //   name: 'OnlineApplication',
    //   component: OnlineApplication,
    //   meta:{requireAuth:true}
    // },    
    // {
    //   path: '/MyOffice',
    //   name: 'MyOffice',
    //   component: MyOffice,
    //   meta:{requireAuth:true}
    // },
    // {
    //   path: '/HandlingDetails',
    //   name: 'HandlingDetails',
    //   component: HandlingDetails,
    //   meta:{requireAuth:true}
    // },   
    // {
    //   path: '/WeiXinLogin',
    //   name: 'WeiXinLogin',
    //   component: WeiXinLogin,
    // },  
    // {
    //   path: '/LoginSuccess',
    //   name: 'LoginSuccess',
    //   component: LoginSuccess,
    // },  
    // {
    //   path: '/BasicInformationBinding',
    //   name: 'BasicInformationBinding',
    //   component: BasicInformationBinding,
    // }, 
    // {
    //   path: '/Personal',
    //   name: 'Personal',
    //   component: Personal,
    //   meta:{requireAuth:true}
    // }, 
    // {
    //   path: '/MyMaterials',
    //   name: 'MyMaterials',
    //   component: MyMaterials,
    //   meta:{requireAuth:true}
    // }, 
    {
      path: '/CharacteristicVillage/HanYuan',
      name: 'HanYuan',
      component: HanYuan,
    },    
    {
      path: '/CharacteristicVillage/AnLe',
      name: 'AnLe',
      component: AnLe,
    },
    {
      path: '/CharacteristicVillage/DaShu',
      name: 'DaShu',
      component: DaShu,
    },
    {
      path: '/CharacteristicVillage/FuLin',
      name: 'FuLin',
      component: FuLin,
    },
    {
      path: '/CharacteristicVillage/FuQuan',
      name: 'FuQuan',
      component: FuQuan,
    },
    {
      path: '/CharacteristicVillage/FuXiang',
      name: 'FuXiang',
      component: FuXiang,
    },
    {
      path: '/CharacteristicVillage/FuZhuang',
      name: 'FuZhuang',
      component: FuZhuang,
    },
    {
      path: '/CharacteristicVillage/HeNan',
      name: 'HeNan',
      component: HeNan,
    },
    {
      path: '/CharacteristicVillage/HuangMu',
      name: 'HuangMu',
      component: HuangMu,
    },
    {
      path: '/CharacteristicVillage/JiuXiang',
      name: 'JiuXiang',
      component: JiuXiang,
    },
    {
      path: '/CharacteristicVillage/MaLie',
      name: 'MaLie',
      component: MaLie,
    },
    {
      path: '/CharacteristicVillage/NiMei',
      name: 'NiMei',
      component: NiMei,
    },
    {
      path: '/CharacteristicVillage/PianMa',
      name: 'PianMa',
      component: PianMa,
    },
    {
      path: '/CharacteristicVillage/QianYu',
      name: 'QianYu',
      component: QianYu,
    },
    {
      path: '/CharacteristicVillage/QingXi',
      name: 'QingXi',
      component: QingXi,
    },
    {
      path: '/CharacteristicVillage/ShaiJin',
      name: 'ShaiJin',
      component: ShaiJin,
    },
    {
      path: '/CharacteristicVillage/ShunHe',
      name: 'ShunHe',
      component: ShunHe,
    },
    {
      path: '/CharacteristicVillage/TangJia',
      name: 'TangJia',
      component: TangJia,
    },
    {
      path: '/CharacteristicVillage/WuSiHe',
      name: 'WuSiHe',
      component: WuSiHe,
    },
    {
      path: '/CharacteristicVillage/XiaoBao',
      name: 'XiaoBao',
      component: XiaoBao,
    },
    {
      path: '/CharacteristicVillage/YiDong',
      name: 'YiDong',
      component: YiDong,
    },
    {
      path: '/CharacteristicVillage/YongLi',
      name: 'YongLi',
      component: YongLi,
    },
    // 对于所有的（*代表所有）错误页面，我们都可以重定向到 "/" 中
    {
      path: "*",
      redirect: "/"
    }
  ]
})
//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
